import { Config } from 'config/envConfig';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faEnvelope } from '@fortawesome/free-solid-svg-icons';

import { appLogo } from './Constants.js';
import { LandingPageButton } from '@quyva/shared-ui';
import { useLocation, useNavigate } from 'react-router';

const Navbar = ({ menuItems }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const useSecuredConnection = Config.USE_SECURED_CONNECTION;
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const handleNavigation = (url, ref) => {
        if (url) {
            navigate(url);
        } else {
            if (location.pathname !== '/') {
                navigate('/');
            } else if (ref && ref.current) {
                const yAxisPosition =
                    ref.current.getBoundingClientRect().top +
                    window.scrollY -
                    50;
                window.scrollTo({
                    top: yAxisPosition,
                    behavior: 'smooth',
                });
            }
        }
    };

    const toggleMobileMenu = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    return (
        <nav className='fixed w-full bg-landing-white/95 backdrop-blur-md z-50 border-b border-landing-gray-100 shadow-sm'>
            <div className='max-w-7xl mx-auto px-6 h-20 flex items-center justify-between'>
                {/* Logo */}
                <button
                    onClick={() => handleNavigation(null, menuItems[0]?.ref)}
                    className='flex items-center gap-2'
                    title='Quyva Logo'
                >
                    <img
                        src={appLogo}
                        alt='Quyva'
                        className='h-12 w-auto object-contain transition-transform hover:scale-105'
                        draggable='false'
                    />
                </button>

                {/* Desktop Navigation */}
                <div className='hidden md:flex items-center gap-8'>
                    {menuItems.map((item, index) => (
                        <button
                            key={index}
                            className='text-sm font-semibold text-landing-slate-600 hover:text-landing-blue-500 transition'
                            onClick={() => {
                                handleNavigation(null, item.ref);
                            }}
                        >
                            {item.name}
                        </button>
                    ))}
                </div>

                {/* Desktop Auth Buttons */}
                <div className='hidden md:flex items-center gap-3'>
                    <button
                        onClick={() => handleNavigation('/login')}
                        className='text-sm font-semibold text-landing-slate-700 hover:text-landing-blue-500 transition px-4 py-2'
                    >
                        Sign In
                    </button>
                    <LandingPageButton
                        className="!bg-backgrounds-primary300 !text-texts-primary hover:!bg-backgrounds-primary400 border-none px-5 py-2.5 shadow-sm flex items-center justify-center gap-2 text-sm"
                        onClick={() => handleNavigation('/contactUs')}
                        icon={faEnvelope}
                        text='Contact Us'
                    />
                </div>

                {/* Mobile Menu Button */}
                <button className='md:hidden p-2' onClick={toggleMobileMenu}>
                    <FontAwesomeIcon
                        icon={showMobileMenu ? faTimes : faBars}
                        className='text-landing-slate-700 text-xl'
                    />
                </button>
            </div>

            {/* Mobile Menu */}
            <div 
                className={`md:hidden absolute left-0 right-0 top-20 bg-white shadow-lg transition-all duration-300 ease-in-out ${
                    showMobileMenu ? 'opacity-100 visible max-h-screen' : 'opacity-0 invisible max-h-0'
                } overflow-hidden`}
            >
                <div className='flex flex-col p-6 gap-4'>
                    {menuItems.map((item, index) => (
                        <button
                            key={index}
                            className='text-left font-medium text-landing-slate-700 py-3 border-b border-landing-gray-100 hover:text-landing-blue-500'
                            onClick={() => {
                                handleNavigation(null, item.ref);
                                toggleMobileMenu();
                            }}
                        >
                            {item.name}
                        </button>
                    ))}
                    <div className='flex flex-col gap-3 mt-4'>
                        <button
                            onClick={() => {
                                handleNavigation('/login');
                                toggleMobileMenu();
                            }}
                            className='w-full py-3 text-center font-semibold text-landing-slate-700 border border-landing-gray-200 rounded-lg hover:bg-landing-gray-50'
                        >
                            Sign In
                        </button>
                        <button
                            onClick={() => {
                                handleNavigation('/contactUs');
                                toggleMobileMenu();
                            }}
                            className='w-full py-3 text-center font-semibold text-white bg-landing-blue-500 rounded-lg hover:bg-landing-blue-600'
                        >
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;